import React from 'react';

import './badge-item.scss';

const BadgeItem = ({children}) => {
  return <li><span className="position-badge">{children}</span></li>
}

export default BadgeItem;